import React from "react";
import MaterialsTestingComparison from "./MaterialsTestingComparison";

export default function App() {
  return <MaterialsTestingComparison />;
}
